import axios from 'axios';
import { clientNetwork, profileContract, stacksApi } from '../lib/constants';
import { fetchData, getUserLoadOutUri, save } from '../services/stacks';


// const appOrigin = window.location.origin;
// Constants exports
export const defaultBanner = process.env.PUBLIC_URL + '/default_header.png';
export const bannerName = 'derupt_banner.png';

export const getProfileBasics = async (authId) => {
    let name, address, userStorage, userContacts, deployDate, userContractDeployInfo, errorMsg;
    try {
        const contactRes = await fetchData('followinglist.json');
        userContacts = contactRes?.success ? contactRes?.result : {};

        // Gets address if passed authId is Name
        if (authId && authId.includes('.')) {
            name = authId;
            const validate = await fetch(`${stacksApi[clientNetwork]}/v1/names/${authId}`);
            if (validate.ok) {
                const data = await validate.json();
                if (data?.address) {
                    const { address: nameAddress } = data;
                    address = nameAddress;
                }
            }
        } else {
            address = authId;
            // This runs directly using the authId as a principal and also gets the BNS names if address owns any
            const res = await fetch(`${stacksApi[clientNetwork]}/v1/addresses/stacks/${address}`);
            const data = await res.json();
            if (data?.names?.length > 0) {
                name = data.names[0];
            }
        }

        // Fetch contract deployment information
        userContractDeployInfo = (await axios.get(`${stacksApi[clientNetwork]}/extended/v2/smart-contracts/status?contract_id=${address}.${profileContract}`)).data;
        const contractDeployTx = userContractDeployInfo[`${address}.${profileContract}`]?.found ? userContractDeployInfo[`${address}.${profileContract}`]?.result?.tx_id : undefined;
        // Only attempt to fetch the deploy date if the transaction ID is defined
        if (contractDeployTx !== undefined) {
            const txData = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/tx/${contractDeployTx}`))?.data;
            if (txData) {
                deployDate = txData.burn_block_time_iso.split('T')[0];
            }
        } else {
            console.log('Contract deployment transaction ID is undefined.');
            deployDate = undefined;
        }

        userStorage = await getUserLoadOutUri(address);
    } catch (error) {
        errorMsg = error?.message.match(/Response\s\d{3}/)?.[0] || error?.message;
    }

    return {
        name,
        address,
        deployDate,
        userContacts,
        userStorage,
        errorMsg
    };
};

export const saveToFollowing = async (authorPrincipal, setUserContacts) => {
    try {
        const timestamp = Date.now();
        const dataObj = { [authorPrincipal]: timestamp };
        let contactsData = await fetchData('followinglist.json');
        contactsData = contactsData.success ? contactsData.result : {};
        const dataToSave = {
            content: JSON.stringify({ ...contactsData, ...dataObj }),
            fileName: 'followinglist.json'
        };
        await save(dataToSave);
        contactsData = { ...contactsData, ...dataObj };
        setUserContacts(contactsData);
    } catch (e) {
        console.log('Error while saving following', e);
    }
};

export const removeFromFollowing = async (authorPrincipal, setUserContacts) => {
    try {
        let contactsData = await fetchData('followinglist.json');
        contactsData = contactsData.success ? contactsData.result : {};
        delete contactsData[authorPrincipal];
        const dataToSave = {
            content: JSON.stringify(contactsData),
            fileName: 'followinglist.json'
        };
        await save(dataToSave);
        setUserContacts(contactsData);
    } catch (e) {
        console.log('Error while removing following', e);
    }
};

export const defaultFollowing = async (setUserContacts) => {
    try {
        const dataToSave = {
            content: JSON.stringify({}),
            fileName: 'followinglist.json'
        };
        await save(dataToSave);
        setUserContacts({});
    } catch (e) {
        console.log('Error while resetting following list', e);
    }
};
